import { useEffect } from 'react';
import type { EventBus } from '../../core/EventBus';
import type { PlayerEvents } from '../../core/types';

/**
 * Subscribe to an EventBus event. Auto-cleans on unmount.
 */
export function useEventBus<K extends keyof PlayerEvents>(
  eventBus: EventBus,
  event: K,
  handler: PlayerEvents[K] extends void ? () => void : (data: PlayerEvents[K]) => void,
): void {
  useEffect(() => {
    return eventBus.on(event, handler as any);
  }, [eventBus, event, handler]);
}
